import { render } from "./MdSearchContent.vue?vue&type=template&id=23a95e1c&scoped=true"
import script from "./MdSearchContent.vue?vue&type=script&lang=js"
export * from "./MdSearchContent.vue?vue&type=script&lang=js"

import "./MdSearchContent.vue?vue&type=style&index=0&id=23a95e1c&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a95e1c"]])

export default __exports__